module.exports = __webpack_public_path__ + "static/media/custom-bg-6.63610669.png";